import React from 'react'
import Link from 'gatsby-link';
import { Content } from '../contentful-engine/content';
import { Head } from '../components/head';

export default class ContactPage extends React.Component {
  render () {
    return (
      <div className="page page--contact">
        <Head website={this.props.pathContext.website} />
        <Link to="/" className="page__close"><img src="/cross-white.svg" /></Link>
        <h2>_BRITT GUNS</h2> 
        <h2>_PHOTO AND FILM AFFAIRS</h2>
        <Content document={this.props.pathContext.website.contactText} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/templates/contact.js